const PRIME_TYPES = ["Prime", "Indemnité", "Prime Ségur", "Primes diverses"];

export function quotationLines(quotation) {
  const source = quotation?.products ?? quotation?.Products;
  return Array.isArray(source)
    ? source.filter((item) => item && typeof item === "object")
    : [];
}

export function quotationProductLabel(item) {
  const product = String(
    item.product || item.prestation || item.designation || "",
  ).trim();
  const type = String(item.type || "").trim();
  const generic = ["service", "prestation", "produit", "ligne"].includes(
    type
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase(),
  );
  if (item.isPrime || PRIME_TYPES.includes(type)) {
    const kind = type && !generic ? type : "Prime";
    return product && product !== kind ? `${kind} : ${product}` : product || kind;
  }
  if (product) return product;
  if (!generic && type) return type;
  return String(item.contractType || item.service || "").trim();
}

export function quotationPositions(quotation) {
  return (
    [
      ...new Set(
        quotationLines(quotation)
          .map((item) => item.poste)
          .filter(Boolean),
      ),
    ].join(" · ") ||
    quotation?.qualification ||
    "—"
  );
}

export function quotationServices(quotation) {
  const labels = quotationLines(quotation)
    .map((item) => quotationProductLabel(item))
    .filter(Boolean);
  return [...new Set(labels)].join(" · ") || "—";
}
